"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapiIntegrationToJSON = exports.CapiIntegrationFromJSONTyped = exports.CapiIntegrationFromJSON = exports.instanceOfCapiIntegration = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CapiIntegration interface.
 */
function instanceOfCapiIntegration(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCapiIntegration = instanceOfCapiIntegration;
function CapiIntegrationFromJSON(json) {
    return CapiIntegrationFromJSONTyped(json, false);
}
exports.CapiIntegrationFromJSON = CapiIntegrationFromJSON;
function CapiIntegrationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'capiConnectionId': !(0, runtime_1.exists)(json, 'capi_connection_id') ? undefined : json['capi_connection_id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
    };
}
exports.CapiIntegrationFromJSONTyped = CapiIntegrationFromJSONTyped;
function CapiIntegrationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'dataset_id': value.datasetId,
    };
}
exports.CapiIntegrationToJSON = CapiIntegrationToJSON;
